/**
 * Сериализация PATCH по одному projectId для строки таблицы.
 * Разные StatusButtonCell (Ф, Ц, С, D, PDF) иначе шлют параллельные запросы;
 * ответы приходят не по порядку, mergeSingleProjectInCaches перезаписывает проект целиком — теряются поля.
 */
const tailByProjectId = new Map<string, Promise<void>>();

export function runAfterPendingRowPatches(
  projectId: string,
  task: () => Promise<void>
): void {
  const prev = tailByProjectId.get(projectId) ?? Promise.resolve();
  const next = prev
    .then(() => task())
    .catch(() => {})
    .finally(() => {
      if (tailByProjectId.get(projectId) === next) {
        tailByProjectId.delete(projectId);
      }
    });
  tailByProjectId.set(projectId, next);
}
